module.exports = __webpack_public_path__ + "static/amex-nyc-0b9b1c3df5b77be1be24929acbaf655d.jpg";